import { create } from "zustand";
import { persist } from "zustand/middleware";

type WishlistState = {
	wishlist: number[];
	addToWishlist: (itemId: number) => void;
	removeFromWishlist: (itemId: number) => void;
	clearWishlist: () => void;
	isInWishlist: (itemId: number) => boolean;
};

const useWishlistStore = create<WishlistState>()(
	persist(
		(set, get) => ({
			wishlist: [],
			addToWishlist: (itemId: number) => {
				const { wishlist } = get();
				set({ wishlist: [...wishlist, itemId] });
			},
			removeFromWishlist: (itemId: number) => {
				const { wishlist } = get();
				set({
					wishlist: wishlist.filter((item) => item !== itemId),
				});
			},
			clearWishlist: () => set({ wishlist: [] }),
			isInWishlist: (itemId: number) => {
				const { wishlist } = get();
				return wishlist.some((item) => item === itemId);
			},
		}),
		{
			name: "dailysale-shop-wishlist", // name of the item in storage
			getStorage: () => localStorage, // (optional) by default, 'localStorage' is used
		}
	)
);

export default useWishlistStore;
